import { render, staticRenderFns } from "./CalculatorSidebar.vue?vue&type=template&id=556cc5be&scoped=true"
import script from "./CalculatorSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./CalculatorSidebar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CalculatorSidebar.vue?vue&type=style&index=0&id=556cc5be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556cc5be",
  null
  
)

export default component.exports